/**
 * Sole Color Selector - Syncs selection to line item property
 */

document.addEventListener('DOMContentLoaded', () => {
  // Listen for variant changes to update the sole color property
  document.addEventListener('variant:change', (event) => {
    const variant = event.detail.variant;
    if (!variant) return;
    
    // Find the form and property input
    const form = event.target.closest('form') || document.querySelector('[data-product-form]');
    if (!form) return;
    
    const propertyInput = form.querySelector('input[name="properties[Sole Color]"]');
    const selectedValueDisplay = form.querySelector('.sole-color-selector__selected-value');
    
    // Get the sole color option value from the variant
    // Check all options to find "Sole Color" or "Sole Colour"
    if (variant.options && propertyInput) {
      variant.options.forEach((optionValue, index) => {
        // Get the option name from the product
        const productData = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
        if (productData.options && productData.options[index]) {
          const optionName = productData.options[index].toLowerCase();
          if (optionName.includes('sole color') || optionName.includes('sole colour')) {
            propertyInput.value = optionValue;
            if (selectedValueDisplay) {
              selectedValueDisplay.textContent = optionValue;
            }
          }
        }
      });
    }
  });
  
  // Also handle direct radio button changes for sole color
  const soleColorSelectors = document.querySelectorAll('.sole-color-selector');
  
  soleColorSelectors.forEach(selector => {
    const radios = selector.querySelectorAll('.sole-color-selector__radio');
    
    radios.forEach(radio => {
      radio.addEventListener('change', (e) => {
        const form = e.target.form;
        if (!form) return;
        
        const propertyInput = form.querySelector('input[name="properties[Sole Color]"]');
        const selectedValueDisplay = selector.querySelector('.sole-color-selector__selected-value');
        
        // Get the selected option's text value
        // The radio buttons are linked to variant options, so we need to find the actual color name
        const soleColorAttr = e.target.getAttribute('data-sole-color');
        if (soleColorAttr && propertyInput) {
          // Capitalize the color name
          const colorName = soleColorAttr.split(' ').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ');
          
          propertyInput.value = colorName;
          if (selectedValueDisplay) {
            selectedValueDisplay.textContent = colorName;
          }
        }
      });
    });
  });
});

